<template>
  <div class="specifications">
    <h3 v-if="specifications" class="bold">Specifications</h3>
    <div class="specification-container">
      <div
        v-for="(key, index) in specifications"
        :key="key.name + index"
        class="specifications-flex"
      >
        <div class="inner-specification-flex">
          <div class="specifications-text-box left-spec">
            <span v-if="key.name !== '/title'">{{ key.name }}</span>
          </div>
          <div class="specifications-text-box right-spec">
            <span v-if="key.value">
              <span v-if="key.value !== '/title'">
                {{ key.value }}
              </span>
            </span>
            <div
              v-for="(key2, i) in key.arrayValue"
              v-else
              :key="key2 + i"
            >
              {{ key2 }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProductSpecificationsComponent',
  props: {
    specifications: {
      type: Array,
      required: true
    }
  },
  data() {
    return {};
  },
  mounted() {}
};
</script>

<style lang="less" scoped>
@import '~@eds/vanilla/variables/dark.less';
@import '../assets/common.less';

.specifications {
  width: 100%;
  h3 {
    margin: @space-large 0;
  }
  .specification-container {
    .specifications-flex {
      justify-content: space-between;
      flex-direction: column;
      height: auto;
      padding-bottom: @space-base;
    }

    .specifications-text-box {
      font-size: @font-size;
    }
    .left-spec {
      width: 180 / @px;
      margin-right: 8 / @px;
    }
    .right-spec {
      display: flex;
      flex-direction: column;
      flex: 1;
    }
    .inner-specification-flex {
      display: flex;
      flex-direction: row;
    }

    @media only screen and (max-width: 800px) {
      .inner-specification-flex {
        flex-direction: column;
      }
      .specifications-text-box {
        padding-bottom: @space-base;
      }
    }
  }
}
</style>
